import axios from 'axios'
import {config} from '../config'
export const getStories = (id) =>{
    return axios.get(config.stories+'/'+id)
    .then(function (response) {
        return response
    })
    .catch(function (error) {
      console.log(error);
    })
}

